import { render, staticRenderFns } from "./increment.vue?vue&type=template&id=e891047e&scoped=true"
import script from "./increment.vue?vue&type=script&lang=js"
export * from "./increment.vue?vue&type=script&lang=js"
import style0 from "./increment.vue?vue&type=style&index=0&id=e891047e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e891047e",
  null
  
)

export default component.exports